import heroNavScrollHandler from '../modules/heroNavScrollHandler';
import FeaturesToggle from '../modules/FeaturesToggle';

export default {
    herNavScrollHandler: null,
    FeaturesToggle: null,

    init() {
        this.filterController = new heroNavScrollHandler();
        this.FeaturesToggle = new FeaturesToggle();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/how-it-works.js